import PageLinks from "components/templates/pageLinks/PageLinks";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "PAGE_LINKS",
  label: "Liste de liens",
  Component: PageLinks,
  initialContents: [
    {
      key: "pageLinks",
      type: elementsTypes.CARDS_LIST,
      value: "",
      children: [],
    },
  ],
};
